import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";

class CorrectedAgeCalculator {
    public static calculateCorrectedAge(chronologicalBirth: Date, numberOfPrematureWeeks: number): Date {
        const normalGestationWeeks = 40;
        if (!chronologicalBirth || isNaN(numberOfPrematureWeeks))
            return null;

        const diffWeeks = normalGestationWeeks - numberOfPrematureWeeks;
        return LuxonDateTimeParser.parse(chronologicalBirth)?.plus({ weeks: diffWeeks }).toJSDate();
    }
}

export { CorrectedAgeCalculator };
